(function () {
  function getProductInfo(element) {
    return element.closest('product-info') || document.querySelector('product-info[id^="MainProduct"]');
  }

  function parseVariantOptions(card, fallbackOptionValue) {
    try {
      var options = JSON.parse(card.getAttribute('data-variant-options') || '[]');
      return Array.isArray(options) ? options : [fallbackOptionValue];
    } catch (error) {
      return [fallbackOptionValue];
    }
  }

  function syncNativeVariant(card, optionValue, dispatchChange) {
    var productInfo = getProductInfo(card);
    if (!productInfo) return null;

    var variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return null;

    var options = parseVariantOptions(card, optionValue);
    var changedInput = null;

    options.forEach(function (value, index) {
      var field = variantSelects.querySelectorAll('.product-form__input')[index];
      if (!field) return;

      var select = field.querySelector('select');
      if (select) {
        var matchingOption = Array.from(select.options).find(function (option) {
          return option.value === value;
        });
        if (matchingOption) {
          select.value = value;
          changedInput = select;
        }
        return;
      }

      var radio = Array.from(field.querySelectorAll('input[type="radio"]')).find(function (input) {
        return input.value === value;
      });
      if (radio) {
        radio.checked = true;
        changedInput = radio;
      }
    });

    if (changedInput && dispatchChange !== false) {
      changedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return changedInput;
  }

  function setVariantIdInputs(productInfo, variantId) {
    if (!productInfo || !variantId) return;

    var sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
    productInfo.querySelectorAll('#product-form-' + sectionId + ', #product-form-installment-' + sectionId).forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      if (!input) return;

      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function buildVariantSectionUrl(productInfo, variantId) {
    var productUrl = productInfo.dataset.url;
    var sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
    if (!productUrl || !variantId || !sectionId) return null;

    var separator = productUrl.indexOf('?') >= 0 ? '&' : '?';
    return productUrl + separator + 'variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(sectionId);
  }

  function getSelectedVariantFromHtml(html) {
    var selectedVariantScript = html.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariantScript || !selectedVariantScript.textContent.trim()) return null;

    try {
      return JSON.parse(selectedVariantScript.textContent);
    } catch (error) {
      return null;
    }
  }

  function getVariantFromCard(card) {
    try {
      var variant = JSON.parse(card.getAttribute('data-variant-json') || 'null');
      return variant && variant.id ? variant : null;
    } catch (error) {
      return null;
    }
  }

  function replaceById(productInfo, html, id) {
    var sectionId = productInfo.dataset.section;
    var source = html.querySelector('#' + id + '-' + sectionId);
    var destination = productInfo.querySelector('#' + id + '-' + sectionId);
    if (!source || !destination) return;

    destination.innerHTML = source.innerHTML;
    destination.classList.toggle('hidden', source.classList.contains('hidden'));
  }

  function updateDirectCheckoutButtons(productInfo, available) {
    productInfo.querySelectorAll('[data-tfg-direct-checkout]').forEach(function (button) {
      button.toggleAttribute('disabled', !available);
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  }

  function refreshProductFormReferences(productForm) {
    if (!productForm) return;

    productForm.submitButton = productForm.querySelector('[type="submit"]');
    productForm.submitButtonText = productForm.submitButton && productForm.submitButton.querySelector('span');
    if (document.querySelector('cart-drawer') && productForm.submitButton) {
      productForm.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
  }

  function updateBuyButtonsFromHtml(productInfo, html) {
    if (!productInfo || !html) return false;

    var productForm = productInfo.querySelector('product-form');
    var sourceButtons = html.querySelector('[data-tfg-buy-buttons]');
    var destinationButtons = productInfo.querySelector('[data-tfg-buy-buttons]');
    if (!productForm || !sourceButtons || !destinationButtons) return false;

    destinationButtons.outerHTML = sourceButtons.outerHTML;
    refreshProductFormReferences(productForm);
    return true;
  }

  function updateProductFormAvailability(productInfo, available) {
    var productForm = productInfo.querySelector('product-form');
    if (!productForm || typeof productForm.toggleSubmitButton !== 'function') return;

    productForm.toggleSubmitButton(!available, available ? window.variantStrings.addToCart : window.variantStrings.soldOut);
    var submitButton = productForm.querySelector('[type="submit"]');
    if (submitButton) submitButton.setAttribute('aria-disabled', available ? 'false' : 'true');
  }

  function applyVariantSection(card, productInfo, html, variant) {
    if (!variant) return false;

    replaceById(productInfo, html, 'price');
    replaceById(productInfo, html, 'Sku');
    replaceById(productInfo, html, 'Inventory');
    replaceById(productInfo, html, 'Volume');
    replaceById(productInfo, html, 'Volume-Note');
    replaceById(productInfo, html, 'Price-Per-Item');
    replaceById(productInfo, html, 'Quantity-Rules');

    if (typeof productInfo.updateMedia === 'function') {
      productInfo.updateMedia(html, variant.featured_media && variant.featured_media.id);
    }
    if (typeof productInfo.updateURL === 'function') {
      productInfo.updateURL(productInfo.dataset.url, variant.id);
    }

    setVariantIdInputs(productInfo, variant.id);
    if (!updateBuyButtonsFromHtml(productInfo, html)) {
      updateProductFormAvailability(productInfo, variant.available);
      updateDirectCheckoutButtons(productInfo, variant.available);
    }
    markSelectedCard(card);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: productInfo.dataset.section,
          html: html,
          variant: variant,
        },
      });
    }

    return true;
  }

  function updateVariantFromCard(card, optionValue, variantId) {
    var productInfo = getProductInfo(card);
    if (!productInfo || !variantId) return;

    markSelectedCard(card);
    setVariantIdInputs(productInfo, variantId);
    var changedInput = syncNativeVariant(card, optionValue, false);
    var requestUrl = buildVariantSectionUrl(productInfo, variantId);

    if (!requestUrl) {
      if (changedInput) {
        changedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    fetch(requestUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var variant = getSelectedVariantFromHtml(html) || getVariantFromCard(card);
        if (!applyVariantSection(card, productInfo, html, variant) && changedInput) {
          changedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      })
      .catch(function (error) {
        console.error(error);
        if (changedInput) changedInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
  }

  function syncDirectCheckoutStateFromForm(button) {
    var productForm = button.closest('product-form');
    var submitButton = productForm && productForm.querySelector('[type="submit"]');
    if (!submitButton) return;

    var isDisabled = submitButton.hasAttribute('disabled') || submitButton.getAttribute('aria-disabled') === 'true';
    button.toggleAttribute('disabled', isDisabled);
    button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
  }

  function syncAllDirectCheckoutButtons() {
    document.querySelectorAll('[data-tfg-direct-checkout]').forEach(syncDirectCheckoutStateFromForm);
  }

  function markSelectedCard(card) {
    var selector = card.closest('.tfg-bundle-selector');
    if (!selector) return;

    selector.querySelectorAll('.bundle-card').forEach(function (item) {
      var isSelected = item === card;
      item.classList.toggle('selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function getPdpSourceHandle() {
    try {
      var sourceHandle = new URLSearchParams(window.location.search).get('pdp_src');
      if (!sourceHandle || !/^[a-z0-9][a-z0-9-]*$/i.test(sourceHandle)) return '';
      return sourceHandle;
    } catch (error) {
      return '';
    }
  }

  function markActiveProductOptionCards(scope) {
    var shell = (scope || document).querySelector('[data-pdp-product-options-shell]');
    if (!shell) return;

    var currentHandle = shell.getAttribute('data-current-product-handle');
    if (!currentHandle) return;

    shell.querySelectorAll('[data-pdp-product-option-card]').forEach(function (card) {
      var isCurrentProduct = card.getAttribute('data-product-handle') === currentHandle;
      card.classList.toggle('selected', isCurrentProduct);
      card.setAttribute('aria-current', isCurrentProduct ? 'page' : 'false');
    });
  }

  function restoreSourceProductOptions() {
    var sourceHandle = getPdpSourceHandle();
    if (!sourceHandle) {
      markActiveProductOptionCards(document);
      return;
    }

    var shell = document.querySelector('[data-pdp-product-options-shell]');
    if (!shell) return;

    var currentHandle = shell.getAttribute('data-current-product-handle');
    if (!currentHandle || sourceHandle === currentHandle) {
      markActiveProductOptionCards(document);
      return;
    }

    fetch('/products/' + encodeURIComponent(sourceHandle))
      .then(function (response) {
        if (!response.ok) throw new Error('Source product options could not be loaded.');
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var sourceShell = html.querySelector('[data-pdp-product-options-shell]');
        var sourceOptions = sourceShell && sourceShell.querySelector('[data-pdp-product-options]');
        if (!sourceOptions || !sourceShell.innerHTML.trim()) return;

        shell.innerHTML = sourceShell.innerHTML;
        markActiveProductOptionCards(document);
      })
      .catch(function (error) {
        console.error(error);
        markActiveProductOptionCards(document);
      });
  }

  window.selectCarnivalBundle = function (element, optionValue, variantId) {
    if (!element) return;
    updateVariantFromCard(element, optionValue, variantId);
  };
  window.selectCarnivalBundle._tfgPdp = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAllDirectCheckoutButtons();
      restoreSourceProductOptions();
    });
  } else {
    syncAllDirectCheckoutButtons();
    restoreSourceProductOptions();
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('input.product-variant-id[name="id"]')) return;
    var productForm = event.target.closest('product-form');
    if (!productForm) return;

    productForm.querySelectorAll('[data-tfg-direct-checkout]').forEach(syncDirectCheckoutStateFromForm);
  });

  document.addEventListener('click', function (event) {
    var bundleCard = event.target.closest('[data-pdp-bundle-card]');
    if (!bundleCard) return;

    event.preventDefault();
    updateVariantFromCard(
      bundleCard,
      parseVariantOptions(bundleCard, '')[0],
      bundleCard.getAttribute('data-variant-id')
    );
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      var sectionId = event.data.sectionId;

      document.querySelectorAll('product-info[data-section="' + sectionId + '"]').forEach(function (productInfo) {
        if (event.data.html && updateBuyButtonsFromHtml(productInfo, event.data.html)) return;
        updateProductFormAvailability(productInfo, variant.available);
      });

      document.querySelectorAll('.tfg-bundle-selector .bundle-card').forEach(function (card) {
        if (card.getAttribute('data-variant-id') === String(variant.id)) {
          markSelectedCard(card);
        }
      });

      document.querySelectorAll('product-info[data-section="' + sectionId + '"] [data-tfg-direct-checkout]').forEach(function (button) {
        button.toggleAttribute('disabled', !variant.available);
        button.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      });

      window.setTimeout(setupAllInsideCarousels, 0);
    });
  }

  function animateAccordion(details) {
    if (!details || details.dataset.tfgAnimating === 'true') return;

    var content = details.querySelector('.tfg-pdp-accordion__content');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!content || reduceMotion) {
      details.open = !details.open;
      return;
    }

    details.dataset.tfgAnimating = 'true';
    var isOpening = !details.open;
    var targetPadding = window.getComputedStyle(content).paddingBottom;

    if (isOpening) {
      details.open = true;
      content.style.height = '0px';
      content.style.paddingBottom = '0px';
      content.style.opacity = '0';
      content.offsetHeight;
      content.style.paddingBottom = targetPadding;
      content.style.height = content.scrollHeight + 'px';
      content.style.opacity = '1';
    } else {
      content.style.height = content.scrollHeight + 'px';
      content.style.paddingBottom = targetPadding;
      content.style.opacity = '1';
      content.offsetHeight;
      content.style.height = '0px';
      content.style.paddingBottom = '0px';
      content.style.opacity = '0';
    }

    var fallbackTimer = null;
    var finish = function (transitionEvent) {
      if (transitionEvent && transitionEvent.target !== content) return;
      if (!isOpening) details.open = false;
      content.style.height = '';
      content.style.paddingBottom = '';
      content.style.opacity = '';
      delete details.dataset.tfgAnimating;
      content.removeEventListener('transitionend', finish);
      window.clearTimeout(fallbackTimer);
    };

    content.addEventListener('transitionend', finish);
    fallbackTimer = window.setTimeout(finish, 420);
  }

  function updateInsideCarouselDots(box, activeIndex) {
    if (!box) return;

    box.querySelectorAll('[data-tfg-inside-dot]').forEach(function (dot) {
      var isActive = Number(dot.getAttribute('data-tfg-inside-dot')) === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function getInsideCarouselPagePositions(box) {
    var track = box && box.querySelector('.tfg-inside-box__track');
    if (!track) return [0];

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    if (maxScroll <= 2) return [0];

    var pageSize = Math.max(1, track.clientWidth);
    var pageCount = Math.max(2, Math.ceil(maxScroll / pageSize) + 1);
    return Array.from({ length: pageCount }, function (_, index) {
      if (index === pageCount - 1) return maxScroll;
      return Math.min(maxScroll, Math.round(index * pageSize));
    });
  }

  function getInsideCarouselDirectSlides(box) {
    var track = box && box.querySelector('.tfg-inside-box__track');
    if (!track) return [];

    return Array.from(track.querySelectorAll('[data-tfg-inside-slide]')).filter(function (slide) {
      return slide.parentElement === track;
    });
  }

  function getInsideCarouselContentWidth(box) {
    var track = box && box.querySelector('.tfg-inside-box__track');
    var slides = getInsideCarouselDirectSlides(box);
    if (!track || !slides.length) return 0;

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return slides.reduce(function (total, slide) {
      return total + slide.getBoundingClientRect().width;
    }, 0) + (gap * Math.max(0, slides.length - 1));
  }

  function syncInsideCarouselMode(box) {
    var track = box && box.querySelector('.tfg-inside-box__track');
    var viewport = box && box.querySelector('.tfg-inside-box__viewport');
    if (!box || !track || !viewport) return false;

    box.classList.remove('tfg-inside-box--autoplay');

    var slides = getInsideCarouselDirectSlides(box);
    var hasOverflow = slides.length > 1 && viewport.clientWidth > 0 && getInsideCarouselContentWidth(box) > viewport.clientWidth + 2;
    var useAutoplay = box.getAttribute('data-tfg-inside-autoplay') === 'true' && hasOverflow;

    box.classList.toggle('tfg-inside-box--autoplay', useAutoplay);
    box.classList.toggle('tfg-inside-box--overflow', hasOverflow);
    box.classList.toggle('tfg-inside-box--static', !hasOverflow);

    if (!hasOverflow && track.scrollLeft !== 0) {
      track.scrollLeft = 0;
    }

    return useAutoplay;
  }

  function setInsideCarouselPage(box, pageIndex) {
    var track = box && box.querySelector('.tfg-inside-box__track');
    if (!track) return;

    var positions = getInsideCarouselPagePositions(box);
    var safeIndex = Math.max(0, Math.min(pageIndex, positions.length - 1));
    track.scrollTo({
      left: positions[safeIndex] || 0,
      behavior: 'smooth',
    });
    updateInsideCarouselDots(box, safeIndex);
  }

  function updateInsideCarouselActivePage(box) {
    var track = box && box.querySelector('.tfg-inside-box__track');
    if (!track) return;

    var positions = getInsideCarouselPagePositions(box);
    var activeIndex = 0;
    var activeDistance = Infinity;
    positions.forEach(function (position, index) {
      var distance = Math.abs(position - track.scrollLeft);
      if (distance < activeDistance) {
        activeDistance = distance;
        activeIndex = index;
      }
    });
    updateInsideCarouselDots(box, activeIndex);
  }

  function setupInsideCarousel(box) {
    var dots = box && box.querySelector('[data-tfg-inside-dots]');
    var track = box && box.querySelector('.tfg-inside-box__track');
    var nav = box && box.querySelector('.tfg-inside-box__nav');
    if (!box || !track) return;

    var isAutoplay = syncInsideCarouselMode(box);
    if (isAutoplay) {
      if (nav) nav.hidden = true;
      if (dots) {
        dots.hidden = true;
        dots.innerHTML = '';
      }
      return;
    }

    var positions = getInsideCarouselPagePositions(box);
    if (nav) nav.hidden = positions.length <= 1;
    if (!dots) return;

    if (positions.length <= 1) {
      dots.hidden = true;
      dots.innerHTML = '';
      return;
    }

    dots.hidden = false;
    dots.innerHTML = positions.map(function (_, index) {
      return '<button type="button" class="tfg-inside-box__dot' + (index === 0 ? ' is-active' : '') + '" data-tfg-inside-dot="' + index + '" aria-label="Go to page ' + (index + 1) + '" aria-selected="' + (index === 0 ? 'true' : 'false') + '"></button>';
    }).join('');
    updateInsideCarouselActivePage(box);

    if (track.dataset.tfgInsideScrollReady !== 'true') {
      track.dataset.tfgInsideScrollReady = 'true';
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          updateInsideCarouselActivePage(box);
        });
      });
    }
  }

  function setupAllInsideCarousels() {
    document.querySelectorAll('[data-pdp-inside-box]').forEach(setupInsideCarousel);
  }

  function scrollInsideCarousel(box, index) {
    setInsideCarouselPage(box, index);
  }

  setupAllInsideCarousels();
  window.addEventListener('resize', function () {
    window.clearTimeout(window.tfgInsideCarouselResizeTimer);
    window.tfgInsideCarouselResizeTimer = window.setTimeout(setupAllInsideCarousels, 150);
  });
  document.addEventListener('product-info:loaded', setupAllInsideCarousels);
  document.addEventListener('shopify:section:load', setupAllInsideCarousels);

  document.addEventListener('keydown', function (event) {
    var standardsTab = event.target.closest('[data-pdp-standard-tab]');
    if (!standardsTab) return;

    var tabs = Array.from(standardsTab.closest('[data-pdp-standards]')?.querySelectorAll('[data-pdp-standard-tab]') || []);
    if (!tabs.length) return;

    var currentIndex = tabs.indexOf(standardsTab);
    var nextIndex = currentIndex;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    tabs[nextIndex].focus();
    tabs[nextIndex].click();
  });

  document.addEventListener('click', function (event) {
    var accordionSummary = event.target.closest('[data-tfg-pdp-accordion] > summary');
    if (accordionSummary) {
      event.preventDefault();
      animateAccordion(accordionSummary.parentElement);
      window.setTimeout(setupAllInsideCarousels, 430);
      return;
    }

    var reviewLink = event.target.closest('[data-tfg-review-scroll]');
    if (reviewLink) {
      var selector = reviewLink.getAttribute('data-scroll-selector') || '.jdgm-rev-widg';
      var target = document.querySelector(selector);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    var insideDot = event.target.closest('[data-tfg-inside-dot]');
    if (insideDot) {
      var dotBox = insideDot.closest('[data-pdp-inside-box]');
      scrollInsideCarousel(dotBox, Number(insideDot.getAttribute('data-tfg-inside-dot')) || 0);
      return;
    }

    var insidePrev = event.target.closest('[data-tfg-inside-prev]');
    var insideNext = event.target.closest('[data-tfg-inside-next]');
    if (insidePrev || insideNext) {
      var arrowBox = event.target.closest('[data-pdp-inside-box]');
      var activeDot = arrowBox && arrowBox.querySelector('[data-tfg-inside-dot].is-active');
      var currentIndex = activeDot ? Number(activeDot.getAttribute('data-tfg-inside-dot')) || 0 : 0;
      scrollInsideCarousel(arrowBox, currentIndex + (insideNext ? 1 : -1));
      return;
    }

    var standardsTab = event.target.closest('[data-pdp-standard-tab]');
    if (standardsTab) {
      var standards = standardsTab.closest('[data-pdp-standards]');
      if (!standards) return;

      var country = standardsTab.getAttribute('data-pdp-standard-tab');
      standards.querySelectorAll('[data-pdp-standard-tab]').forEach(function (tab) {
        var isActive = tab === standardsTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      standards.querySelectorAll('[data-pdp-standard-panel]').forEach(function (panel) {
        var isActive = panel.getAttribute('data-pdp-standard-panel') === country;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tfg-direct-checkout]');
    if (!button) return;

    event.preventDefault();

    var productForm = button.closest('product-form');
    var form = productForm && productForm.querySelector('form');
    if (!form || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    var formData = new FormData(form);
    window.tfgApplyUpsellTrackingProperties?.(formData, form, productForm);
    var variantId = formData.get('id');
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          if (productForm && typeof productForm.handleErrorMessage === 'function') {
            productForm.handleErrorMessage(response.description || response.message);
          }
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          return;
        }

        if (productForm && typeof productForm.normalizeDuplicateVariantLines === 'function') {
          return productForm.normalizeDuplicateVariantLines(response).then(function () {
            window.location.href = '/checkout';
          });
        }

        window.location.href = '/checkout';
      })
      .catch(function (error) {
        console.error(error);
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  });
})();
